module.exports = __webpack_public_path__ + "img/SB.2e9685ce.png";